import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { S25ItemModule } from "../s25-item/s25.item.module";
import { S25ItemUnwrapperComponent } from "../s25-item/s25.item.unwrapper.component";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";
import { S25NotificationPolicyComponent } from "./s25.notification.policy.component";
import { S25ObjectNotifyPolicyHostComponent } from "./s25.object.notify.policy.host.component";
import { S25NotificationPolicySectionsComponent } from "./s25.notification.policy.sections.component";

import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25IconButtonComponent } from "../../standalone/s25.icon.button.component";
import { S25FadingSuccessMsgComponent } from "../s25-fading-success-msg/s25.fading.success.msg.component";

@NgModule({
    declarations: [S25NotificationPolicyComponent, S25ObjectNotifyPolicyHostComponent],
    imports: [
        CommonModule,
        FormsModule,
        S25ItemModule,
        S25DropdownPaginatedModule,
        S25LoadingInlineModule,
        S25MultiselectModule,
        S25ItemUnwrapperComponent,
        S25IconComponent,
        S25IconButtonComponent,
        S25NotificationPolicySectionsComponent,
        S25FadingSuccessMsgComponent,
    ],
    providers: [S25NotificationPolicyComponent, S25ObjectNotifyPolicyHostComponent],
    exports: [S25NotificationPolicyComponent, S25ObjectNotifyPolicyHostComponent],
})
export class S25NotificationPolicyModule {
    constructor() {}
}
